/*
 * Changes:
 * - Added 'use client' directive for Next.js 13+ compatibility
 * - File contains client-side features: React context provider and Jotai state management
 */

'use client'

import {oauthCredentialsState} from '@frnt/base/atoms'
import {Axios} from '@frnt/base/tools'
import {useAtomValue} from 'jotai'
import PropTypes from 'prop-types'

const ResourceApiServiceProvider = ({children, Context, handleUnauthorized, host, timeout = 10000, valueCallback = (any) => ({})}) => {
  const oauthCredentials = useAtomValue(oauthCredentialsState)
  const axios = Axios.getInstance(
    host,
    () => {
      return oauthCredentials?.accessToken
    },
    timeout
  )
  // axios.interceptors.response.use(
  //   (response) => {
  //     return response
  //   },
  //   (error) => {
  //     if (!!handleUnauthorized && error.response && error.response.status === 401) {
  //       return handleUnauthorized(error)
  //     }
  //
  //     return Promise.reject(error)
  //   }
  // )

  const value = valueCallback(axios)
  return <Context.Provider value={value}>{children}</Context.Provider>
}

ResourceApiServiceProvider.propTypes = {
  children: PropTypes.any,
  Context: PropTypes.object.isRequired,
  handleUnauthorized: PropTypes.func,
  host: PropTypes.string.isRequired,
  valueCallback: PropTypes.func,
  timeout: PropTypes.number
}

export {ResourceApiServiceProvider}
